<template>
    <div :key="'mydeals'">
        <dot-loader class="loader" v-if="!allFinished" :class="{noAccess: noAccess}"></dot-loader>
        <NoAccess v-if="noAccess"></NoAccess>
        <div v-show="allFinished" v-if="!noAccess">
            <h2 class="headline" v-if="customerView">{{ presetName }}</h2>
            <div v-if="!customerView" class="section">
                <transition name="fade" mode="out-in">
                    <div>
                        <div class="preset-section" :key="1">
                            <h2 v-if="!preset">My Deals</h2>
                            <div v-if="preset" id="headline-section" :class="[currentBreakpoint]">
                                <h2 class="headline"> {{ preset.name }}</h2>
                                <div style="display: flex; flex-flow:row;">
                                    <div class="info">
                                        <span class="text">
                                            <unicon :name="visibility_icon" fill="#394956c7"
                                                    :style="{paddingRight: '5px'}">
                                            </unicon>
                                            {{ visibility }}
                                        </span>
                                        <span class="text">
                                            <unicon name="user" fill="#394956c7" :style="{paddingRight: '5px'}">
                                            </unicon>
                                            {{ user_fullname }}
                                        </span>
                                    </div>
                                    <span v-if="allowEditing" class="icon icon-edit"
                                          @click="showHeadlineDialog = true"></span>
                                </div>
                            </div>
                            <div v-if="preset" id="filter-section" :class="[currentBreakpoint]">
                                <div class="half preset-section-container">
                                    <PresetFilter :columns="presetColumns"
                                                  @update="filterUpdated"></PresetFilter>
                                </div>
                                <div v-if="!customerView" class="half right">
                                    <div style="margin-top: .7rem">
                                        <div class="commentIntern">
                                            <text-area :disabled="customerView||!allowEditing"
                                                       @input="updateCommentIntern"
                                                       id="hinweisIntern" title="Hinweis (intern)"
                                                       :text="commentIntern"></text-area>
                                        </div>
                                        <div class="nav right">
                                            <div class="preset-section right">
                                                <Navbox class="navbox">
                                                    <template slot="noStyling">
                                                        <div class="button_container">
                                                            <AdaButton icon="icon-favorite"
                                                                       class="preset-section-button"
                                                                       title="My Deals" type="grey" @click="toMyDeals">
                                                            </AdaButton>
                                                            <AdaButton class="preset-section-button" title="Link teilen"
                                                                       icon="icon-share" type="purple"
                                                                       @click="showShareDialog = true">
                                                            </AdaButton>
                                                            <AdaButton class="preset-section-button"
                                                                       title="Aktualisieren" @click="loadNewPresetData"
                                                                       :loading="updatingPreset" icon="redo"
                                                                       :unicon="true">
                                                            </AdaButton>
                                                            <AdaButton v-if="allowEditing" class="preset-section-button"
                                                                       title="Speichern" @click="savePreset"
                                                                       :loading="updatingPreset" icon="icon-save">
                                                            </AdaButton>
                                                        </div>
                                                    </template>
                                                </Navbox>
                                            </div>

                                        </div>
                                    </div>
                                    <div v-if="presetId && !customerView" class="section">
                                        <div>
                                            <div class="progressbar">
                                                <completion-rate :editable="allowEditing"></completion-rate>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <div v-if="!(customerView&&!preset)" class="section" style="margin-bottom: 0;">
                <date-selection-container class="date-selection"></date-selection-container>
            </div>
            <div class="section">
                <accordion v-if="presetId">
                    <accordion-item v-if="!customerView || dashboardVisible" :active="true">
                        <template slot="accordion-trigger">
                            <span v-if="!customerView" @click="toggleVisibility('visibility_dashboard', ...arguments)"
                                  :class="{'icon':true,'icon-visible':dashboardVisible,'icon-hidden':!dashboardVisible}"></span>
                            <h3>Dashboard</h3>
                        </template>
                        <template slot="accordion-content">
                            <div class="dashboard" :class="{disabled: (customerView||!allowEditing)}">
                                <div class="section-top">
                                    <div
                                        :class="{ half: (!customerView||(customerView&&comment!== '')) && currentBreakpoint === 'lg' }">
                                        <div class="kpiContainer">
                                            <div class="kpiWrapper">
                                                <DashboardKPIBox :title="'Ad Impressions'" :value="getImpressionSum"
                                                                 :gain="getImpressionsDelta.delta" :color="'blue'">
                                                </DashboardKPIBox>
                                            </div>
                                            <div class="kpiWrapper">
                                                <DashboardKPIBox :title="'Revenue'" :value="getRevenueSum"
                                                                 :gain="getRevenueDelta.delta" :color="'noGradBlue'"
                                                ></DashboardKPIBox>
                                            </div>
                                            <div class="kpiWrapper">
                                                <DashboardKPIBox :title="'eCPM'" :value="getEcpm"
                                                                 :gain="getEcpmDelta.delta" :color="'blue'"
                                                                 :flip-background="true">
                                                </DashboardKPIBox>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="!customerView||(customerView&&comment!== '')"
                                         :class="{ half: currentBreakpoint === 'lg',right: currentBreakpoint === 'lg'}">
                                        <div class="dashboard_comment_container">
                                            <text-area
                                                :disabled="customerView||!allowEditing" @input="updateComment"
                                                title="Hinweis" id="hinweis" :text="comment"></text-area>
                                        </div>
                                    </div>
                                </div>
                                <div class="section-center">
                                    <chart-grid :key="loadingKey" @loadingFinished="chartsLoaded = true"
                                                @loadingStarted="chartsLoaded = false"
                                                :is-editable="!customerView && allowEditing"
                                    ></chart-grid>
                                </div>
                            </div>
                        </template>
                    </accordion-item>

                    <accordion-item v-if="!customerView || tableVisible" :active="true">
                        <!-- This slot will handle the title/header of the accordion and is the part you click on -->
                        <template slot="accordion-trigger">
                            <span v-if="!customerView"
                                  @click="toggleVisibility('visibility_table', ...arguments);"
                                  :class="{'icon':true,'icon-visible':tableVisible,'icon-hidden':!tableVisible}"></span>
                            <span v-if="!customerView"
                                  :class="{'icon':true,'icon-apply':true}"></span>
                            <h3>Tabelle</h3>
                        </template>
                        <!-- This slot will handle all the content that is passed to the accordion -->
                        <template slot="accordion-content">
                            <deal-table  @loadingFinished="tableLoaded=true"
                                        :key="loadingKey"></deal-table>
                        </template>
                    </accordion-item>
                </accordion>
                <div v-if="!presetId">
                    <deal-table @loadingFinished="tableLoaded=true"></deal-table>
                </div>

            </div>
        </div>
        <Confirm :key="componentKey" :to="to" :refreshKey="componentKey"
                 title="Möchtest du vorher deine Änderungen speichern?" :show="showConfirmLeave"
                 @close="showConfirmLeave = false;"
                 @onok="this.saveOrUpdate" @oncancel="this.discardChanges">
        </Confirm>
        <ShareDialog :show="showShareDialog" v-if="!customerView && preset"
                     @close="showShareDialog = false"></ShareDialog>
        <Dialog :show="showHeadlineDialog" @close="showHeadlineDialog = false" :show-close-button="true"
                id="headlineDialog">
            <div class="content">
                <h4>Preset Einstellungen</h4>
                <Input label="Verfasser" v-model="headlineData.author_name" :disabled="true" width="100%"></Input>
                <Input label="Name" v-model="headlineData.name" @enter="updateHeadline" width="100%"></Input>
                <div class="visibility wrapper">
                    <div class="icon_wrapper">
                        <Checkbox title="Private" id="0" v-model="headlineData.private"></Checkbox>
                        <unicon name="lock-alt" fill="#d0d4da"></unicon>
                    </div>
                    <div class="icon_wrapper">
                        <Checkbox title="Public" id="1" v-model="headlineData.public">></Checkbox>
                        <unicon name="unlock-alt" fill="#d0d4da"></unicon>
                    </div>
                </div>
                <div class="button_container">
                    <AdaButton title="Speichern" @click="updateHeadline"
                               :loading="vuexState.updatingHeadline"></AdaButton>
                    <AdaButton type="grey" title="Abbrechen" @click="closeHeadlineDialog"></AdaButton>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Utils from "../../scripts/utils";
import DealTable from "../DealTable";
import Accordion from "../../components/accordion/Accordion";
import AccordionItem from "../../components/accordion/AccordionItem";
import ChartGrid from "./components/ChartGrid";
import AdaButton from "../../components/buttons/AdaButton";
import PresetFilter from "./components/preset/PresetFilter";
import CompletionRate from "./components/CompletionRate";
import DateSelectionContainer from "../../components/datePicker/DateSelectionContainer";
import Confirm from "../../components/dialogs/Confirm";
import DashboardKPIBox from "./components/DashboardKPIBox";
import TextArea from "../../components/box/TextArea";
import Navbox from "../../components/box/NavBox";
import ShareDialog from "../../components/dialogs/ShareDialog";
import Dialog from "../../components/dialogs/Dialog";
import Checkbox from "../../components/inputs/Checkbox";
import Input from "../../components/inputs/Input";
import NoAccess from "./components/NoAccess";

export default {
    name: "MyDeals",
    components: {
        NoAccess,
        Input,
        Checkbox,
        Dialog,
        ShareDialog,
        Navbox,
        TextArea,
        DashboardKPIBox,
        Confirm,
        DateSelectionContainer,
        CompletionRate,
        PresetFilter, AdaButton, ChartGrid, AccordionItem, Accordion, DealTable
    },
    data() {
        return {
            keyCount: 0,
            showShareDialog: false,
            showHeadlineDialog: false,
            componentKey: 0,
            kpisLoading: true,
            showConfirmLeave: false,
            fn_dashboardLoader: null,
            savingDashboard: false,
            showSelectPresetDialog: false,
            presetLoaded: false,
            tableLoaded: false,
            chartsLoaded: false,
            loadingKey: 0,
            next: null,
            from: null,
            to: null,
            presetFilterData: null,
            fnCreatePreset: null,
            currentBreakpoint: null,
            headlineData: {
                name: null,
                private: null,
                public: null,
                author_name: null,
                author_id: null,
                user_id: null
            },
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.vuexState.changesMade && this.allowEditing) {
            this.to = to.path;
            this.from = from;
            this.showConfirmLeave = true;
            this.next = next;
            this.forceRerender();
        } else {
            next();
        }
    },
    async mounted() {
        this.fnCreatePreset = () => {
            this.savePreset();
        };
        if (typeof this.$route.params.id !== "undefined") {
            this.loadPreset();
            sessionStorage.setItem('latestPresetId', this.$route.params.id);
        } else if (sessionStorage.getItem('latestPresetId')) {
            if (sessionStorage.getItem('latestPresetId') !== "null" && sessionStorage.getItem('latestPresetId') !== "undefined") {
                this.$router.push({name: 'mydeals', params: {id: sessionStorage.getItem('latestPresetId')}});
                this.loadPreset();
            }
        }

    },
    beforeDestroy() {
        if (typeof this.$route.params.id !== "undefined" && !this.customerView) {
            this.$root.$off('savePresetHeader', this.fnCreatePreset);
            this.$root.$off('dashboardLoader', this.fn_dashboardLoader);
        }
    },
    created() {
        this.currentBreakpoint = Utils.getCurrentBreakpoint();
        window.addEventListener('resize', () => {
            this.currentBreakpoint = Utils.getCurrentBreakpoint();
        });
    },
    computed: {
        /*  currentBreakpoint(){
            return Utils.getCurrentBreakpoint();
          },*/
        allFinished() {
          let test = this.$route.name === 'mydealsall' ? this.tableLoaded :
              this.presetLoaded &&
              (this.tableLoaded || (!this.tableVisible && this.customerView)) &&
              (this.chartsLoaded || (!this.dashboardVisible && this.customerView)) &&
              (!this.kpisLoading || this.customerView);
          console.log(this.tableLoaded)
            return test;
        },
        kpis() {
            return this.$store.state.presets.kpis;
        },
        getRevenueSum() {
            return typeof this.kpis['revenue'] !== 'undefined' ? this.kpis['revenue'].toLocaleString('de-DE') + ' €' : '0 €';
        },
        getRevenueDelta() {
            if (typeof this.kpis['revenue'] === 'undefined' && typeof this.kpis['revenue_delta'] === 'undefined') {
                return {delta: 0, positive: 0};
            }
            return {delta: this.calcDeltaValues(this.kpis['revenue'], this.kpis['revenue_delta'], "€", 2)};
        },
        getImpressionSum() {
            return typeof this.kpis['impressions'] !== 'undefined' ? parseFloat(this.kpis['impressions']).toLocaleString('de-DE') + ' AIs' : '0 AIs';
        },
        getImpressionsDelta() {
            if (typeof this.kpis['impressions'] === 'undefined' && typeof this.kpis['impressions_delta'] === 'undefined') {
                return {delta: 0, positive: 0};
            }
            return {delta: this.calcDeltaValues(this.kpis['impressions'], this.kpis['impressions_delta'], "AIs", 0)};
        },
        getEcpmDelta() {
            if (typeof this.kpis['ecpm'] === 'undefined' && typeof this.kpis['ecpm_delta'] === 'undefined') {
                return {delta: 0, positive: 0};
            }
            return {delta: this.calcDeltaValues(this.kpis['ecpm'], this.kpis['ecpm_delta'], "€", 2)};
        },
        getEcpm() {
            return typeof this.kpis['ecpm'] !== 'undefined' ? this.kpis['ecpm'].toLocaleString('de-DE') + ' €' : '0 €';
        },
        customerView() {
            let key = this.$route.query.key;
            return typeof key !== 'undefined';
        },
        dashboardVisible() {
            return this.preset && this.preset.visibility_dashboard === 'extern';
        },
        tableVisible() {
            return this.preset && this.preset.visibility_table === 'extern';
        },
        colWidth() {
            return Utils.calcColWidth();
        },
        vuexState() {
            return this.$store.state.presets;
        },
        preset() {
            return this.vuexState.currentPreset;
        },
        presetName() {
            return this.vuexState.currentPreset ? this.vuexState.currentPreset.name : '';
        },
        presetId() {
            return this.preset ? this.preset.id : null;
        },
        presetColumns() {
            let ret = JSON.parse(JSON.stringify(this.preset.columns));
            if (ret !== null) {
                ret = ret.sort(this.sortByDisplayName);
            }
            return ret;
        },
        dates() {
            return this.$store.state.deals.dates;
        },
        comment() {
            return this.preset && this.preset.comment ? this.preset.comment : '';
        },
        commentIntern() {
            return this.preset && this.preset.comment_intern ? this.preset.comment_intern : '';
        },
        visibility() {
            if (this.preset !== null) {
                if (this.preset.public === 0 && this.preset.private === 1) {
                    if (this.preset.author.id !== this.preset.user.id) {
                        return 'shared';
                    } else {
                        return 'private';
                    }
                } else if (this.preset.public === 1 && this.preset.private === 0) {
                    return 'public';
                } else if (this.preset.public === 1 && this.preset.private === 1) {
                    //public ? + share?
                    return 'public';
                }
            }
            return '';
        },
        visibility_icon() {
            if (this.visibility === "shared" || this.visibility === "private") {
                return 'lock-alt';
            } else {
                return 'unlock-alt';
            }

        },
        user_fullname() {
            if (this.preset) {
                return this.preset.author.first_name + ' ' + this.preset.author.last_name;
            }
            return '';
        },
        updatingPreset() { //loader
            if (this.vuexState.updatingPreset === false) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.loadingKey++;
            }
            return this.vuexState.updatingPreset;
        },
        allowEditing() {
            if (this.presetId !== null) {
                // eslint-disable-next-line no-undef
                return this.preset.author_id === parseInt(sso.getSsoUser().id);
            }
            return true;
        },
        headlinePrivate() {
            return this.headlineData.private;
        },
        headlinePublic() {
            return this.headlineData.public;
        },
        noAccess() {
            return this.vuexState.noAccess;
        }
    },
    methods: {
        calcDeltaValues(sum, deltaSum, unit, digits) {

            sum = parseFloat(sum);
            deltaSum = parseFloat(deltaSum);
            if (sum === 0 && deltaSum === 0) {
                return "0 " + unit + " (+0%)";
            }
            if (sum === 0) {
                return "-" + this.toLocaleString(deltaSum, digits) + " " + unit + " (-" + this.toLocaleString(deltaSum, 2) + "%)";
            }

            if (deltaSum === 0) {
                return "+" + this.toLocaleString(sum, digits) + " " + unit + " (+" + this.toLocaleString(sum, 0) + "%)";
            }

            if (deltaSum > sum) {
                return "-" + this.toLocaleString((deltaSum - sum), digits) + " " + unit + " (-" + this.toLocaleString(((deltaSum - sum) / deltaSum) * 100, 2) + "%)";
            }

            return "+" + this.toLocaleString((sum - deltaSum), digits) + " " + unit + " (+" + this.toLocaleString(((sum - deltaSum) / deltaSum) * 100, 2) + "%)";
        },
        toLocaleString(number, digits) {
            number = parseFloat(number);
            return number.toLocaleString('de-DE', {
                minimumFractionDigits: digits,
                maximumFractionDigits: digits
            })
        },
        async loadPreset() {
            await this.fetchPreset();
            this.loadKpis();
            if (!this.customerView) {
                this.fn_dashboardLoader = (load) => {
                    this.savingDashboard = load;
                };
                this.$root.$on('dashboardLoader', this.fn_dashboardLoader);
                this.$root.$on('savePresetHeader', this.fnCreatePreset);
            }
            if (this.vuexState.currentPreset) this.presetFilterData = this.vuexState.currentPreset.columns;
            this.keyCount++;
        },
        saveOrUpdate() {
            this.savePreset();
            this.next();
        },
        discardChanges() {
            this.$store.commit('presets/setChangesMade', false);
            this.next();
        },
        forceRerender() {
            this.componentKey += 1;
        },
        async fetchPreset() {
            this.presetLoaded = false;
            await this.$store.dispatch('presets/setCurrentPreset', this.$route.params.id);
            this.keyCount++;
            this.presetLoaded = true;
        },
        async savePreset() {
            this.$root.$emit('presetLoader', true);
            this.saveDashboard();
            await this.$store.dispatch('presets/update', this.presetFilterData);
            this.$root.$emit('presetLoader', false);
            this.loadKpis();
        },
        filterUpdated(data) {
            data.forEach((col) => {
                delete col.templates;
            });
            this.presetFilterData = data;
            if (this.presetLoaded) {
                this.$store.commit('presets/setChangesMade', true);
                this.$store.commit('presets/updateTmpFilterData', {data: data})
            }
        },
        calcColWidth() {
            let colNum = 6;
            if (this.currentBreakPoint === 'xs' || this.currentBreakPoint === 'xxs') {
                colNum = 3;
            } else if (this.currentBreakPoint === 'sm' || this.currentBreakPoint === 'md') {
                colNum = 6;
            }
            let width = window.innerWidth * 0.9 * 0.5;
            // let width = window.innerWidth > 1400 ? 1400 : window.innerWidth;
            let colWidth = (width - (15 * (colNum + 1))) / colNum;
            colWidth = colWidth * 3 + 30;
            return colWidth;
        },
        toggleVisibility(name, ev) {
            ev.stopPropagation();
            let newVisibility = this.preset[name] === "intern" ? "extern" : "intern";
            if (name === 'visibility_dashboard') {
                this.$store.commit('presets/setDashboardVisibility', newVisibility);
            } else if (name === 'visibility_table') {
                this.$store.commit('presets/setTableVisibility', newVisibility);
            }
            if (this.chartsLoaded) {
                this.$store.commit('presets/setChangesMade', true);
            }
        },
        updateComment(text) {
            this.$store.commit('presets/updateComment', text);
        },
        updateCommentIntern(text) {
            this.$store.commit('presets/updateCommentIntern', text);
        },
        saveDashboard: function () {
            this.$root.$emit('saveDashboardHeader', true);
        },
        isDashboardEditable() {
            if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                return false;
            } else if (typeof this.$route.query.key !== 'undefined') {
                return false;
            }
            return true;
        },
        toMyDeals() {
            sessionStorage.setItem('latestPresetId', null);
            this.$router.push({name: 'mydealsall'});
        },
        sortByDisplayName(a, b) {
            if (a.display_name < b.display_name) {
                return -1;
            }
            if (a.display_name > b.display_name) {
                return 1;
            }
            return 0;
        },
        async fetchKPIs() {
            console.log('fetch kpis')
            this.kpisLoading = true;
            let dates = {};
            if (typeof this.dates !== 'undefined' && this.dates.length > 0) {
                dates = {start: this.dates[0], end: this.dates[this.dates.length - 1]};
            }
            await this.$store.dispatch('presets/fetchKpis', {
                preset_id: this.presetId,
                dates: dates,
                presetColumns: this.$store.state.presets.tmpFilterData ? this.$store.state.presets.tmpFilterData : this.$store.state.presets.currentPresetColumns
            });
            this.kpisLoading = false;
        },
        async loadKpis() {
            this.kpisLoading = true;
            await this.fetchKPIs();
            this.kpisLoading = false;
        },
        resetHeadlineData() {
            if (this.preset) {
                this.headlineData.name = this.preset.name;
                this.headlineData.author_name = this.user_fullname;
                this.headlineData.private = this.preset.private === 1;
                this.headlineData.public = this.preset.public === 1;
                this.headlineData.author_id = this.preset.author_id;
                this.headlineData.user_id = this.preset.user_id;
            }
        },
        closeHeadlineDialog() {
            this.showHeadlineDialog = false;
            this.resetHeadlineData();
        },
        async updateHeadline() {
            let json = JSON.parse(JSON.stringify(this.headlineData));
            json.private = json.private === true ? 1 : 0;
            json.public = json.public === true ? 1 : 0;
            await this.$store.dispatch('presets/updateHeadline', json);
            this.showHeadlineDialog = false;
        },
        loadNewPresetData() {
            //this.loadingKey++;
            this.loadKpis();
        }
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        $route(to) {
            if (typeof to.params.id !== "undefined") {
                this.fetchPreset();
                sessionStorage.setItem('latestPresetId', to.params.id);
            } else {
                if (sessionStorage.getItem('latestPresetId')) {
                    if (sessionStorage.getItem('latestPresetId') !== null && sessionStorage.getItem('latestPresetId') !== "null") {
                        this.$router.push({
                            name: 'mydeals',
                            params: {id: sessionStorage.getItem('latestPresetId')}
                        });
                    }
                }
                this.$store.commit('presets/resetCurrentPreset');
            }
        },
        dates() {
            if (this.presetId) {
                this.loadKpis();
            }
        },
        allFinished(value) {
            if (value && this.headlineData.name === null) {
                this.resetHeadlineData();
            }
        },
        headlinePrivate(value) {
            this.headlineData.public = value === false;
        },
        headlinePublic(value) {
            this.headlineData.private = value === false;
        }
    }
}
</script>

<style lang="scss" scoped>
.dashboard {
    width: 100%;
    margin: auto;

    &:not(.disabled) {
        .half.right {
            margin: 0;
        }

        .dashboard_comment_container {
          :deep( textarea) {
                border: 1px solid #eceef0;
                height: 173px;

                &:focus {
                    padding-bottom: 6px;
                    //border: 1px solid #00b6ed;
                    border-bottom: 2px solid #00b6ed;
                }
            }
        }
    }
}

.loader.noAccess {
    display: none;
}

.section {
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
}

.section-small {
    display: inline-block;
}

.section-large {
    display: inline-block;
    margin-right: 15px;
    margin-top: -15px;
}

.center-boxes {
    margin-bottom: 15px;
}

.loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
}

h2, #headline-section, .info {
    transition: all 0.3s ease-in-out;
}

#headline-section {
    display: flex;
    flex-flow: wrap;
    align-items: center;

    &.md, &.sm, &.xs {
        h2 {
            margin-top: 60px;
        }

        .info, .icon-edit {
            margin-top: 40px;
        }
    }

    &.sm, &.xs {
        flex-flow: column;
        align-items: flex-start;

        h2 {
            margin-bottom: 0;
        }

        .info, .icon-edit {
            margin: 0;

            .text {
                &:first-child {
                    padding-left: 0;
                }

                &:not(:last-child):after {
                    margin-left: 20px !important;
                }
            }
        }

        .icon-edit {
            margin-left: 15px;
        }
    }

    &.xs {
        .info .text {
            padding: 0 10px;
        }
    }

    .unicon {
        position: relative;
        top: 3px;
    }

    .info {
        margin: 0 20px;

        .text {
            font-size: 16px;
            font-weight: 500;
            padding: 0 20px;
            color: #394956c7;

            &:not(:last-child):after {
                content: '';
                border-right: 1px solid #394956;
                margin-left: 50px;
            }
        }
    }

    .icon-edit {
        font-size: 20px;
        cursor: pointer;
        transition: all 0.2s ease-in;
        position: relative;
        top: 5px;

        &:hover {
            color: #00b6ed;
        }
    }
}

#filter-section {
    display: flex;
    flex-flow: wrap;

    .half {
        display: flex;
        flex-flow: column;
        width: 50%;
        margin: 0;
    }

  :deep( .presetContainer ){
        width: 100%;
    }

    &.md, &.sm, &.xs {
        flex-flow: column;

      :deep(.presetContainer) {
            margin-top: 15px;
            margin-bottom: 0;
        }

        .half {
            width: 100%;
        }

        .navbox {
            position: absolute;
            top: 5px;
            left: 0;
            width: 100%;
            padding: 0 8px 8px 0;
            background-color: transparent;

          :deep( .button_container ){
                display: flex;
                flex-flow: row;

                .preset-section-button {
                    width: 33%;
                    max-width: 250px;

                    &:not(:last-child) {
                        padding-right: 15px;
                    }
                }
            }

          :deep( button) {
                margin-bottom: 0;
            }
        }
    }
}


:deep(.presetContainer ){
    margin-top: 0;
    margin-bottom: 3rem;
}


.top-box {
    display: inline-block;
    text-align: center;
}

.top-box:not(:last-child) {
    margin-right: 15px;
}

.kpi-box {
    background-color: #fff;
}

.middle-kpi {
    margin-top: 15px;
    margin-bottom: 15px;
}

.kpi-box-wrapper {
    background-color: unset !important;
    margin-top: 1rem;
    padding: 0 !important;
}

.icon {
    margin-right: 1rem;
    font-size: 2em;
    display: flex;
}

.icon-visible {
    color: #d70364;
}

.preset-section-container {
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
}

.preset-section.right {
    //width: 300px;
}

:deep(.preset-section-button button, .button) {
    width: 100%;
}

:deep( .navbox) {

    .button_container .preset-section-button:not(:last-child) {
        button {
            width: 100%;
            margin-bottom: 10px;
        }
    }
}

.confirm {
    padding-top: 3rem;
}


.kpiWrapper {
    width: calc(100% / 3);
    padding: 10px;
    display: inline-block;

    &.large {
        width: calc((100% / 3) * 2);
    }
}


@media (min-width: 768px) and (max-width: 1300px) {
    .kpiWrapper {
        width: calc(100% / 3);
        padding: 10px;

        &.large {
            width: calc(100% / 3);
        }
    }
}

@media (max-width: 767px) {
    .kpiWrapper {
        width: 92vw;
        max-width: 100%;

        &.large {
            width: 92vw;
        }
    }

    .progressbar-wrapper {
        width: 100vw;
        margin-left: -2rem;
    }

}


.progressbar-wrapper {
    width: 49%;
    margin-top: 1rem;
}

.progressbar {
    margin-top: 1.5rem;
}

.progress-infos {
    margin-bottom: 1rem;
}

.date-selection {
    margin-bottom: 1rem;
    margin-top: 1rem;
    display: inline-block;
}

.textarea {
    width: 49%;
    display: inline-block;
}

.right {
    float: right;
}

.save-button {
    width: 15rem;
    float: right;
    display: inline-block;
}

.kpis {
    margin-top: 4rem;
    margin-bottom: 4rem;
}

.half {
    width: 49%;
    display: inline-block;
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.smaller {
    width: 41%;
}


.kpiContainer {
    margin-top: 1.5rem;
}

.commentIntern {
    display: inline-block;
    width: 60%;
}

.nav {
    width: 30%;
    display: inline-block;
}

:deep( .section .container.date-selection) {
    margin-bottom: 0;
}

#headlineDialog {
    .content {
        display: flex;
        flex-flow: column;
        width: 100%;
    }

    .wrapper {
        display: flex;
        flex-flow: wrap;
    }

    .icon_wrapper {
        display: flex;
        align-items: center;
        margin-right: 10px;

        .checkbox-container {
            margin-right: 10px;
        }
    }

    .visibility .icon_wrapper:first-child .checkbox-container {
        margin-left: 0;
    }

    .button_container {
        display: flex;
        flex-flow: row;
        margin-top: 30px;

      :deep( button) {
            margin-right: 15px;
        }
    }
}
</style>